module.exports = __webpack_public_path__ + "f0ec6a3f065a7ec647faa0a9638ca8cb.svg";